<template>
  <div class="container">
    <div class="header">
      <div :class="[isTrue|| missionInfo.izAdopt==1?'disBut':'but']" v-if="region=='taskDetail'" @click="receivetaks">领取任务</div>
      <el-dialog
        title=""
        :visible.sync="isActivation"
        width="30%"
        :before-close="handleClose"
       >
        <span>个人账号认证成功后，才可以领取任务哦，是否去认证？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isActivation = false">取 消</el-button>
          <el-button  @click="ConfirmActive">去认证</el-button>
        </span>
      </el-dialog>
      <div class="but" @click="showModel" v-if="region!='taskDetail'">查看进度</div>
      <div class="shop-name" v-if="region=='taskDetail'">{{missionInfo.name}}</div>
      <div class="shop-name" v-if="region=='hallDetail'">
        {{missionInfo.missionName}}
        <span style="font-size: 14px;font-weight: 100">（任务流水号: {{missionInfo.taskSerialCode}}）</span>
        <div v-if="region=='hallDetail'&&missionInfo.taskStatus == 0" class="status-name">已结束</div>
        <div v-if="region=='hallDetail'&&missionInfo.taskStatus == 1" class="status-name">待提交</div>
        <div v-if="region=='hallDetail'&&missionInfo.taskStatus == 2" class="status-name">评审中</div>
        <div v-if="region=='hallDetail'&&missionInfo.taskStatus == 3" class="status-name">待签约</div>
        <div v-if="region=='hallDetail'&&missionInfo.taskStatus == 4" class="status-name">待结算</div>
        <div v-if="region=='hallDetail'&&missionInfo.taskStatus == 5" class="status-name">已完成</div>
      </div>
      <div class="shop-time">
<!--        <div class="time-hea">2天前发布</div>-->
        <div class="operation">
          <div class="times" v-if="region=='taskDetail'">
            <div class="time-tit">活动时间：</div>
            <div class="time">
              <div class="state">起 {{missionInfo.activityStartTime}}</div>
              <div class="end">止 {{missionInfo.activityEndTime}}</div>
            </div>
          </div>
          <div class="times" v-if="region=='hallDetail'">
            <div class="time-tit">活动时间：</div>
            <div class="time">
              <div class="state">起 {{missionInfo.missionStartTime}}</div>
              <div class="end">止 {{missionInfo.missionEndTime}}</div>
            </div>
          </div>

          <div class="collection">
            <div class="col-img" v-if="region=='taskDetail'">
              <img src="../../../static/image/task/collection.svg" alt v-if="missionInfo.izCollection == 0" @click="collection"/>
              <img src="../../../static/image/task/select-collection.svg" alt v-if="missionInfo.izCollection == 1" @click="cancelcollection"/>
              <div class="col-text">收藏任务</div>
            </div>
            <div class="col-img">
              <div class="col-text blue" @click="uploadTemplate">下载模板</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "../../api/config";
import manage from "../../api/manage";

export default {
  name: "taskDetailHeader",
  props: ["region","missionInfo"],
  components: {},
  data() {
    return {
      isTrue:false,
      isActivation:false,
    };
  },
  created() {
  },
  methods: {
    ConfirmActive(){   //去认证
       this.isActivation = false
       this.$router.push({path:'/userInfo/certiInfo'})
    },
    handleClose(done) {
           this.$confirm('确认关闭？')
             .then(_ => {
               done();
             })
             .catch(_ => {});
     },
    showModel() {
      this.$emit("showModel");
    },
    //下载作品模板pdf
    async uploadTemplate() {
      try {
        let data = {}
        let fileName = '作品模板.pdf';
        const res = await manage.downloadFile('/api/task/uploadTemplate',fileName,data)
      } catch (e) {
        this.$message(e.data ? e.data.message : e.message);
        throw e
      }
    },
    //收藏
    async collection(){
      try {
        let obj = {
          "missionCode": this.missionInfo.missionCode,
          "missionEndTime": this.missionInfo.activityEndTime,
          "missionId": this.missionInfo.id,
          "missionName": this.missionInfo.name,
          "missionStartTime": this.missionInfo.activityStartTime,
          "squarePicture":this.missionInfo.squarePicture,
        }
        let id = this.missionInfo.id
        const res = await this.$http.collection(obj)
        this.$parent.getTaskDetail(id)
        // this.gettaskdetails(id)
      } catch (e) {
        this.$message(res.message);
        throw e
      }
    },
    //取消收藏
    async cancelcollection(){
      try{
        let id = this.missionInfo.id
        const res = await this.$http.cancelCollectionByMissionId(id)
        this.$parent.getTaskDetail(id)
      } catch(e){
        this.$message(e.data ? e.data.message : e.message);
        throw e
      }
    },
    //领取任务
    async receivetaks(){
      try {
        if(this.missionInfo.izAdopt==1){  //已领取
          this.$message.warning('任务已被领取')
        }else{

          let id = this.missionInfo.id
          const res = await this.$http.submittask(id)
          if(res.code == 200){
            this.isTrue = true
            this.$message.success(res.message,2000);
            setTimeout(()=>{
              this.$router.push({
                path: "/hall/hall"
              });
            },2500)

          }else{
            this.isTrue = false

            if(res.message == '您未进行设计师认证，无法领取该任务！'){
               this.isActivation = true
            }else{
               this.$message(res.message);
            }

          }
          this.$parent.getTaskDetail(id)
        }
      } catch (e) {

        this.$message(e.data ? e.data.message : e.message);
        throw e
      }
    },
  },
};
</script>


<style scoped>
.shop-name {
  font-size: 25px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 39px;
  color: #3a3a3a;
  opacity: 1;
  width: 80%;
}
.shop-time {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 20px;
  color: #c7c7c7;
  opacity: 1;
}
.col-text {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 20px;
  color: #3a3a3a;
  opacity: 1;
}
.blue {
  color: #658fff;
  margin: 0 0 0 46px;
  border-bottom: solid 1px #658fff;
}
.but {
  background: #f5d759;
  opacity: 1;
  border-radius: 7px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #3a3a3a;
  opacity: 1;
  /* position: absolute;
  right: 19%; */
  float: right;
  border: solid 1px #ffffff;
  padding: 10px 30px;
  cursor: pointer;
}
.disBut{
  color: rgba(0,0,0,.25);
  background-color: #eeeeee;
  opacity: 0.7;
  border-radius: 7px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  /* color: #3a3a3a; */
  opacity: 1;
  /* position: absolute;
  right: 19%; */
  float: right;
  border: solid 1px #ffffff;
  padding: 10px 30px;
  cursor: pointer;
}
.time-tit {
  display: inline-block;
  float: left;
}
.time {
  display: inline-block;
}
.time-hea {
  margin: 21px 0 0 0;
}
.operation {
  margin: 9px 0 0 0;
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.collection {
  display: flex;
  align-items: center;
  margin: 10px 0 0 0;
}
.col-img img {
  width: 27px;
  height: 26px;
}
.col-img {
  display: flex;
  align-items: center;
}
  .status-name{
    width: 20%;
    float: right;
    font-size: 24px;
    color: #DFB876;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/taskDetailHeader/taskDetailHeader.vue